import { Component } from '@angular/core';
import { HomePage } from '../pages/home/home';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = HomePage;
  
  constructor(){}
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts